/** @format */
import {
	ICartItem,
	ModernPromotionResponse,
	ProductVO,
	PromotionDetailsMapV1,
	PromotionDetailsMapV2
} from '@shared/data-access/interfaces';
import { Observable, map } from 'rxjs';

import { CheckoutFlow } from '@shared/data-access/enums';
import { CookieService } from 'libs/shared/utils/services/src/lib/cookie.service';
import { DiscountEligibilityDao } from '@shared/data-access/dao';
import { Injectable } from '@angular/core';
import { ModernCheckoutCartEvaluatorService } from './modern-checkout-cart-evaluator.service';
import { ProductService } from './product/product.service';

@Injectable({
	providedIn: 'root'
})
export class DiscountEligibilityService {
	// Interface stuff might come later
	constructor(
		private cookieService: CookieService,
		private cartEvaluatorService: ModernCheckoutCartEvaluatorService,
		private discountDao: DiscountEligibilityDao,
		private productService: ProductService
	) {}

	// Modern returns "<ProductPromotionResponse[]>"
	// Legacy returns "<ProductPromotionCollection>"
	public getPromoList$(productList: ProductVO[] | ICartItem[]): Observable<any> {
		const checkoutFlow = this.getCheckoutFlow();

		if (checkoutFlow === CheckoutFlow.LEGACY) {
			// Details endpoint with catEntryIDs
			return this.discountDao.getLegacyProductPromoList(productList);
		} else if (checkoutFlow === CheckoutFlow.MODERN) {
			// New plp endpoint using ecodes instead of catentryIds
			return this.discountDao.getModernProductPromoList(productList);
		}
	}

	// Modern returns "<PromotionResponse>"
	// Legacy returns "<string>"
	public getPromoDescription$(
		checkoutKey?: string,
		promotionId?: number,
		discountId?: string
	): Observable<any> {
		const checkoutFlow = this.getCheckoutFlow();

		if (
			checkoutFlow === CheckoutFlow.LEGACY &&
			checkoutKey !== undefined &&
			promotionId !== undefined
		) {
			// This is just the getPromotionDescription that already exists
			return this.discountDao.getPromotionDescription(checkoutKey, promotionId);
		} else if (checkoutFlow === CheckoutFlow.MODERN) {
			// And this is the getLongDescription already being used in modern already
			return this.discountDao
				.getLongDescription(discountId)
				.pipe(map((response) => response.longMessage));
		}
	}

	public getPromoMessage$(ecode: string, sku?: string) {
		const checkoutFlow = this.getCheckoutFlow();

		if (checkoutFlow === CheckoutFlow.MODERN) {
			return this.discountDao.getPromoMessage(ecode, sku);
		}
	}

	public getItemLevelPromoDescription$(
		ecode?: string,
		sku?: string | string[],
		parentExternalKey?: any,
		deviceChannelId?: any,
		useNewPricingService?: boolean
	): Observable<PromotionDetailsMapV1 | PromotionDetailsMapV2 | ModernPromotionResponse | null> {
		const checkoutFlow = this.getCheckoutFlow();

		if (checkoutFlow === CheckoutFlow.LEGACY) {
			return this.productService
				.getPromotionsByProductId$(
					parentExternalKey,
					deviceChannelId,
					sku,
					useNewPricingService,
					1
				)
				.pipe(
					map((data) => {
						if (
							useNewPricingService ||
							typeof data?.ProductLevelPromotion !== 'undefined'
						) {
							return data;
						}
						return null;
					})
				);
		}
		return this.discountDao.getPromoMessage(ecode, sku);
	}

	public getCheckoutFlow(): string {
		const modernCheckoutCookie = this.cookieService.get('modern').toLowerCase() === 'true';
		return this.cartEvaluatorService.evaluateCookie(modernCheckoutCookie);
	}
}
